/* GutBio — make the PDP sticky cart agree with the bundle-app buy box.
   The theme's sticky cart uses the native single-variant form + price, which
   the Kaching bundle app does not drive — so it showed the wrong price and its
   button added the plain variant instead of the selected bundle. This routes
   the sticky button through the REAL buy-box add-to-cart (bundle-aware) and
   hides the sticky bar's conflicting native price. Progressive enhancement. */
(function () {
  function realAtc() {
    var info = document.querySelector('[id^="ProductInfo-"]') || document;
    var btns = info.querySelectorAll('.product-form__submit, button[name="add"], [type="submit"]');
    for (var i = 0; i < btns.length; i++) {
      if (!btns[i].closest('.product-sticky-cart')) return btns[i];
    }
    return null;
  }

  function init(root) {
    var sticky = (root && root.querySelector ? root : document).querySelector('.product-sticky-cart');
    if (!sticky || sticky.dataset.gbStickyFix === '1') return;
    sticky.dataset.gbStickyFix = '1';

    // Hide the native single-variant price so it can't conflict with the bundle app.
    var price = sticky.querySelector('[id^="Price-Alt-"]');
    if (price) price.style.display = 'none';

    var busy = false;
    function handle(e) {
      var real = realAtc();
      if (!real) return;            // no buy-box button found → let native behaviour run
      e.preventDefault();
      e.stopImmediatePropagation();
      if (busy) return;
      busy = true;
      setTimeout(function () { busy = false; }, 500);
      real.scrollIntoView({ behavior: 'smooth', block: 'center' });
      real.click();
    }

    var form = sticky.querySelector('form.sticky-cart__form, form');
    if (form) form.addEventListener('submit', handle, true);
    var btn = sticky.querySelector('.product-form__submit, button[name="add"], [type="submit"]');
    if (btn) btn.addEventListener('click', handle, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
